import { emitOrgAuditLog } from '../crud/orgs.crud'
import { emitAiRiskReportView } from '../crud/secure.crud'

export const AUDIT_TAGS = {
  REPORT: 'report',
}

export const emitAIRiskReportViewAuditLog = ({ customerId, error, loadTimeMs, overallScore }) =>
  emitAiRiskReportView(customerId, {
    error,
    loadTimeMs,
    overallScore,
  }).catch((auditError) => {
    console.error('Failed to emit AI Risk Report view audit log', auditError)
  })

export const emitReportExportAuditLog = ({
  organizationId,
  customerId,
  customerName,
  reportName,
  reportType,
  source,
  format,
  outputCount,
  path,
  component,
}) =>
  emitOrgAuditLog({
    organizationId,
    auditLog: {
      eventType: 'app.report.export',
      summary: `Exported ${reportName} as ${String(format || '').toUpperCase()}`,
      tags: [AUDIT_TAGS.REPORT],
      customerId,
      customerName: customerId === '*' ? null : customerName,
      payload: {
        format,
        reportName,
        reportType,
        source,
        outputCount,
      },
      source: {
        feature: 'reports',
        component,
        path,
      },
    },
  }).catch((error) => {
    console.error('Failed to emit report export audit log', error)
  })
